import { ResourceAction } from '../../../authentication/authorization-service';
import { ResourceOperations, ResourceTypes } from '../../../authentication/resources';
import {
  companyActivitiesPathName,
  companyActivitiesTabLabel,
  companyAreaPathName,
  companyContactPersonTabLabel,
  companyHistoryPathName,
  companyHistoryTabLabel,
  companyOffersPathName,
  companyOffersTabLabel,
  companyOverviewPathName,
  companyOverviewTabLabel,
  companyRelationsPathName,
} from '../../../areas/company/company-area-pathnames';
import { companiesAreaAppointmentsTabLabel, companiesAreaAppointmentsTabPathName } from '../../../areas/company/overview/company-overview-area-pathnames';
import { offerAndActivityAreaPathName, offerWizardPathName } from '../../../areas/offer-and-activity/offer-and-activity-area-pathnames';
import { OmnibarEntry } from '../omnibar-interfaces';
import { catalogCorrectionsToggle } from '../utils/catalog-corrections';

const companyRead: ResourceAction[] = [{ resourceOperation: ResourceOperations.Read, resourceType: ResourceTypes.Company }];
const offerCreate: ResourceAction[] = [{ resourceOperation: ResourceOperations.Offer.Create, resourceType: ResourceTypes.Offer }];
const createOfferUrl = `/${offerAndActivityAreaPathName}/${offerWizardPathName}`;

function companyTab(id: string, label: string, path: string, resourceActions = companyRead): OmnibarEntry {
  return {
    id,
    label,
    context: 'company',
    group: 'Virksomhedsområde',
    url: `/${companyAreaPathName}/:contextId/${path}`,
    resourceActions,
    featureToggleRequired: catalogCorrectionsToggle,
  };
}

const functions: OmnibarEntry[] = [
  companyTab('7c1d4e2a-5b9f-4a3c-8e61-2f0d9b7a4c15', companyOverviewTabLabel, companyOverviewPathName),
  companyTab('3e8b6f10-9a2d-4c7e-b5f4-1a6c8d2e9f37', companyContactPersonTabLabel, companyRelationsPathName),
  companyTab('a5f2c9d1-6e3b-4f8a-9c27-4d1b7e0a8f62', companyOffersTabLabel, companyOffersPathName),
  companyTab('d9e4a7b3-2c6f-4e1d-8a95-7b3f0c6e2d48', companyActivitiesTabLabel, companyActivitiesPathName),
  companyTab('2b7f9e5c-8d1a-4b6e-a3c4-9e2d5f8b1a73', companyHistoryTabLabel, companyHistoryPathName, [
    { resourceOperation: ResourceOperations.Read, resourceType: ResourceTypes.CompanyChangeLog },
  ]),
  {
    id: 'f1a8c3e6-4d9b-4e2f-b7a5-3c6e9d1f8b24',
    label: companiesAreaAppointmentsTabLabel,
    context: 'none',
    group: 'Virksomheder',
    url: `/${companyAreaPathName}/${companiesAreaAppointmentsTabPathName}`,
    resourceActions: companyRead,
    featureToggleRequired: catalogCorrectionsToggle,
  },
  {
    id: '6d3b8f1e-7a2c-4c9d-a6e5-8f1b4d7c3e90',
    label: 'Opret tilbud',
    context: 'none',
    group: 'Indsatser',
    callbackFn: () => {
      window.open(createOfferUrl);
    },
    resourceActions: offerCreate,
    featureToggleRequired: catalogCorrectionsToggle,
  },
  {
    id: '9a4e2c7f-1b8d-4f3e-b6a9-5c2e8f1d4b67',
    label: 'Opret tilbud til virksomheden',
    context: 'company',
    group: 'Virksomhed',
    callbackFn: (contextId: string) => {
      window.open(`${createOfferUrl}?companyId=${contextId}`);
    },
    resourceActions: offerCreate,
    featureToggleRequired: catalogCorrectionsToggle,
  },
];

export default functions;
